import { render, staticRenderFns } from "./PassengerComponent.vue?vue&type=template&id=e34cd484&scoped=true"
import script from "./PassengerComponent.vue?vue&type=script&lang=js"
export * from "./PassengerComponent.vue?vue&type=script&lang=js"
import style0 from "./PassengerComponent.vue?vue&type=style&index=0&id=e34cd484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34cd484",
  null
  
)

export default component.exports